/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Form, Button } from 'reactstrap'
import { API } from "../../../config/api";
import { FaTimes } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../Styled.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
import LoaderAction from "../../Loader/LoaderAction"
import axios from "axios";
import ModalAddReusable from "../../Global/ModalAdd";
// generate s

export default function ModalAdminUpdate(props) {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  // Untuk Close Proops Data
  const [propsData, setProopsData] = useState()
  const [getDataCode, setGetCode] = useState()
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [pages, setPages] = useState();
  const [ascending] = useState(0);
  const [getProvince, setGetProvince] = useState([])
  const [getRegency, setGetRegency] = useState([])
  const [getDistrict, setGetDistrict] = useState([])
  const [getSubDistrict, setGetSubDistrict] = useState([])
  const [provinceLoaded, setProvinceLoaded] = useState(false);
  const [cityLoaded, setCityLoaded] = useState(false);
  const [districtLoaded, setDistrictLoaded] = useState(false);
  const [getDataTokenSatuSehat, setGetDataTokenSatuSehat] = useState([]);

  const [errors, setErrors] = useState({});
  let fetchParams = {
    headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
  };



  const [form, setForm] = useState({
    // data awal
    first_name: "",
    last_name: "",
    residence_address: "",
    phone_number: "",
    day_birth: "",
    month_birth: "",
    year_birth: "",
    gender: "",
    // data update
    medical_record_code: "",
    nic_number: "",
    nic_address: "",
    status: "",
    education: "",
    occupation: "",
    nationality: "",

    // wilayah
    regencies: "",
    districts: "",
    sub_district: "",

    token_satu_sehat: "",
  });

  const GenerateTokenSatuSehat = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/generate-token`, fetchParams);
      if (response?.status === 200) {
        setGetDataTokenSatuSehat(response.data);
        setLoading(false);
      }

    } catch (error) {
      setLoading(false);
      Swal.fire({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        showConfirmButton: false
      });
    }
  };

  useEffect(() => {
    if (getDataTokenSatuSehat.length === 0) {
      GenerateTokenSatuSehat()
    }
  }, [getDataTokenSatuSehat])

  const generateCode = async () => {
    const response = await API.post(`user-service/master-codes/generate`,
      {
        type: "emr",
      },
      fetchParams)
    setGetCode(response.data.data)
    if (response?.data.error) {
      swal({
        title: 'Failed',
        text: response.data.message,
        icon: 'error',
        timer: 3000,
        buttons: false
      })
    };
  }

  useEffect(() => {
    generateCode()
  }, [])

  useEffect(() => {
    if (getDataCode) {
      setForm({
        ...form,
        medical_record_code: getDataCode?.number
      });
    }
  }, [getDataCode])


  // const handleChange = (e) => {
  //   setForm({
  //     ...form,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => {
      const updatedForm = { ...prevForm, [name]: value };

      // Reset hanya jika terjadi perubahan nilai
      if (name === "nic_address" && prevForm.nic_address !== value) {
        updatedForm.regencies = "";
        updatedForm.districts = "";
        updatedForm.sub_district = "";
      }
      if (name === "regencies" && prevForm.regencies !== value) {
        updatedForm.districts = "";
        updatedForm.sub_district = "";
      }
      if (name === "districts" && prevForm.districts !== value) {
        updatedForm.sub_district = "";
      }

      return updatedForm;
    });
  };


  // Fetch cities (dijalankan setelah provinces selesai di-load)
  useEffect(() => {
    const fetchDataProvince = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/provinces`, fetchParams);
        setGetProvince(response.data.data.data);

        if (response?.status === 200 || response?.status === 201) {
          setProvinceLoaded(true);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        Swal.fire({
          title: "Failed",
          text: `${error.response?.data?.message || "Error fetching provinces"}`,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    };

    fetchDataProvince();
  }, []);

  // Fetch cities (dijalankan setelah provinces selesai di-load)
  useEffect(() => {
    if (provinceLoaded && form.nic_address) {
      const fetchDataRegencies = async () => {
        try {
          setLoading(true);
          const response = await axios.get(`https://api-ts.signatureanugerah.co.id/api/satu-sehat/cities`, {
            params: {
              province_id: form?.nic_address
            },
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`,
            }
          });
          setGetRegency(response.data.data.data);

          if (response?.status === 200 || response?.status === 201) {
            setCityLoaded(true);
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          Swal.fire({
            title: "Failed",
            text: `${error.response?.data?.message || "Error fetching cities"}`,
            timer: 3000,
            showConfirmButton: false,
          });
        }
      };

      fetchDataRegencies();
    }
  }, [provinceLoaded, form.nic_address]);

  // Fetch districts (dijalankan setelah cities selesai di-load)
  useEffect(() => {
    if (cityLoaded && form.regencies) {
      const fetchDataDistricts = async () => {
        try {
          setLoading(true);
          const response = await API.get(
            `https://api-ts.signatureanugerah.co.id/api/satu-sehat/regencies`, {
            params: {
              city_id: form?.regencies
            },
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`,
            }
          });


          setGetDistrict(response.data.data.data);

          if (response?.status === 200 || response?.status === 201) {
            setDistrictLoaded(true); // Tandai bahwa districts sudah selesai di-load
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          Swal.fire({
            title: "Failed",
            text: `${error.response?.data?.message || "Error fetching districts"}`,
            timer: 3000,
            showConfirmButton: false,
          });
        }
      };

      fetchDataDistricts();
    }
  }, [cityLoaded, form.regencies]);

  // Fetch sub-districts (dijalankan setelah districts selesai di-load)
  useEffect(() => {
    if (districtLoaded && form.districts) {
      const fetchDataSubDistricts = async () => {
        try {
          setLoading(true);
          const response = await API.get(
            `https://api-ts.signatureanugerah.co.id/api/satu-sehat/districts`, {
            params: {
              regency_id: form?.districts
            },
            headers: {
              "Content-Type": "application/json",
              "Authorization": `${token}`,
            }
          });

          setGetSubDistrict(response.data.data.data);

          setLoading(false);
        } catch (error) {
          setLoading(false);
          Swal.fire({
            title: "Failed",
            text: `${error.response?.data?.message || "Error fetching sub-districts"}`,
            timer: 3000,
            showConfirmButton: false,
          });
        }
      };

      fetchDataSubDistricts();
    }
  }, [districtLoaded, form.districts]);



  const handleSubmit = useMutation(async (e) => {
    try {
      setLoading(true)
      e.preventDefault();
      const response = await API.post(`transaction-service/patients/store`, {
        first_name: form?.first_name,
        last_name: form?.last_name,
        gender: form?.gender,
        residence_address: form?.residence_address,
        phone_number: form?.phone_number,
        date_birth: form?.year_birth && form?.month_birth && form?.day_birth ? `${form?.year_birth}-${form?.month_birth}-${form?.day_birth}` : "",
        medical_record_code: form?.medical_record_code,
        nic_number: form?.nic_number,
        // nic_address: form?.nic_address,
        province: form?.nic_address,
        regency: form?.regencies,
        district: form?.districts,
        sub_district: form?.sub_district,
        status: form?.status,
        education: form?.education,
        occupation: form?.occupation,
        nationality: form?.nationality
      }, fetchParams);

      if (response?.status === 200) {
        setLoading(false)
        swal({
          title: 'Success',
          text: response.data.message,
          icon: 'success',
          timer: 5000,
          buttons: false
        });
        props.GetResponseData();
        props.onHide();
        setLoading(false);
      }

    } catch (error) {
      setLoading(false)
      if (error.response && error.response.data.message) {
        // Simpan error berdasarkan field
        setErrors(error.response.data.message);
        swal({
          title: 'Validation Error',
          text: `${error.response.data.message}`,
          icon: 'error',
          timer: 5000,
          buttons: false
        });
      } else {
        swal({
          title: 'Failed',
          text: error.response?.data?.message || 'Terjadi kesalahan',
          icon: 'error',
          timer: 3000,
          buttons: false
        });
      }
    }
  });

  return (
    <div>
      {loading && <LoaderAction />}
      <ModalAddReusable
        isOpen={props.show}
        isClose={props.onHide}
        handleSubmit={handleSubmit.mutate}
        handleChange={handleChange}
        title="Tambah Pasien"
        fields={[
          { label: "Nama Depan", name: "first_name", value: form.first_name },
          { label: "Nama Belakang", name: "last_name", value: form.last_name },
          { label: "Nomor HP", name: "phone_number", value: form.phone_number },
          { label: "Alamat", name: "residence_address", value: form.residence_address },
          {
            label: "Jenis Kelamin", name: "gender", type: "select", value: form.gender,
            options: [
              { label: "Laki-Laki", value: "male" },
              { label: "Wanita", value: "female" },
            ],
          },
          {
            label: "Tanggal Lahir",
            type: "date-picker",
            name: "",
            value: {
              day: form.day_birth,
              month: form.month_birth,
              year: form.year_birth,
            },
          },
          {
            label: "Nomor Rekam Medis",
            name: "medical_record_code",
            value: form.medical_record_code,
            disabled: false,
            extraElement: (
              // Refresh Nomor Rekam Medis
              <Button className="btn btn-sm btn-primary float-end" onClick={generateCode}>
                <i className="fa fa-refresh"></i>
              </Button>
            ),
          },
          { label: "Nomor KTP", name: "nic_number", value: form.nic_number },
          {
            label: "Provinsi",
            name: "nic_address",
            value: form?.nic_address,
            type: "select",
            options: getProvince.map((item) => ({
              value: item.code,
              label: item.name
            })),
          },
          {
            label: "Kabupaten/Kota",
            name: "regencies",
            value: form?.regencies,
            type: "select",
            options: getRegency.map((item) => ({
              value: item.code,
              label: item.name
            })),
            disabled: !form?.nic_address ? true : false
          },
          {
            label: "Kecamatan",
            name: "districts",
            value: form?.districts,
            type: "select",
            options: getDistrict.map((item) => ({
              value: item.code,
              label: item.name
            })),
            disabled: !form?.regencies ? true : false
          },
          {
            label: "Kelurahan/Desa",
            name: "sub_district",
            value: form?.sub_district,
            type: "select",
            options: getSubDistrict.map((item) => ({
              value: item.code,
              label: item.name
            })),
            disabled: !form?.districts ? true : false
          },
          { label: "Status", name: "status", value: form.status },
          { label: "Pendidikan", name: "education", value: form.education },
          { label: "Pekerjaan", name: "occupation", value: form.occupation },
        ]}
      />
    </div>
  );
}
